import { createSlice } from '@reduxjs/toolkit';

import { CourseTypes, INITIAL_LIST_PARAMS } from 'config';
import { WorkoutState } from '../../types/course';

const initialState: WorkoutState = {
  isLoading: false,
  courseList: {},
  courseListParams: { ...INITIAL_LIST_PARAMS, course_type: CourseTypes.BROADCAST },
};

const slice = createSlice({
  name: 'broadcast',
  initialState,
  reducers: {
    broadcastStartLoading(state) {
      state.isLoading = true;
    },

    broadcastHasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    broadcastResetError(state) {
      state.error = undefined;
    },

    getBroadcastListSuccess(state, action) {
      state.isLoading = false;
      state.courseList = action.payload;
    },

    getBroadcastSuccess(state, action) {
      state.isLoading = false;
      state.course = action.payload;
    },

    setBroadcastListParams(state, action) {
      state.courseListParams = action.payload;
    },

    clearBroadcast(state) {
      state.course = undefined;
    },

    clearBroadcastList(state) {
      state.courseList = {};
    },

    clearBroadcastParameters(state) {
      state.courseListParams = {};
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  broadcastStartLoading,
  broadcastHasError,
  broadcastResetError,
  getBroadcastListSuccess,
  getBroadcastSuccess,
  setBroadcastListParams,
  clearBroadcast,
  clearBroadcastParameters,
  clearBroadcastList,
} = slice.actions;
